import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

const STAFF_ROLES = ["super_admin", "admin", "founder", "finance", "teacher", "scolarite", "director", "nurse", "canteen", "staff"];

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("mazid_user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(false);

  const persist = (token, u) => {
    localStorage.setItem("mazid_token", token);
    localStorage.setItem("mazid_user", JSON.stringify(u));
    // Mémorise le portail d'origine pour rediriger correctement à la déconnexion/expiration
    localStorage.setItem("mazid_portal", STAFF_ROLES.includes(u?.role) ? "admin" : "public");
    setUser(u);
  };

  const login = async (identifier, password) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { identifier, password });
      // 2FA OTP flow
      if (data.require_otp) {
        return {
          require_otp: true, pending_id: data.pending_id, channel: data.channel,
          destination_masked: data.destination_masked || data.email_masked,
          email_masked: data.email_masked, dev_otp: data.dev_otp,
        };
      }
      persist(data.access_token, data.user);
      return { require_otp: false, user: data.user };
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async (pending_id, code) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/verify-otp", { pending_id, code });
      persist(data.access_token, data.user);
      return data.user;
    } finally {
      setLoading(false);
    }
  };

  const register = async (payload) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", payload);
      // Nouveau flux : code de confirmation obligatoire à l'ouverture du compte
      if (data.require_otp) {
        return {
          require_otp: true, pending_id: data.pending_id, channel: data.channel,
          destination_masked: data.destination_masked, dev_otp: data.dev_otp,
        };
      }
      persist(data.access_token, data.user);
      return { require_otp: false, user: data.user };
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    localStorage.removeItem("mazid_token");
    localStorage.removeItem("mazid_user");
    setUser(null);
  };

  useEffect(() => {
    // Refresh user info on mount if token exists
    const token = localStorage.getItem("mazid_token");
    if (token && !user) {
      api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => logout());
    }
  }, []);

  return (
    <AuthCtx.Provider value={{ user, setUser, login, verifyOtp, register, logout, loading }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
